<template>
    <div class="body">
        <div class="outlineClass">
            <div class="title d-flex justify-content-between align-items-center">
                <span class="topic"><i class="bi bi-qr-code"></i> QR Scan Result</span>
                <button class="btn btn-danger btn-sm" @click="$emit('close')">
                    <i class="bi bi-x-lg"></i> 
                </button>
            </div>
            
            <div class="itemClass">
                <div v-if="!studentItem || (Array.isArray(studentItem) && studentItem.length === 0)">
                <h5>Not Available This QR</h5>
                </div>

                <div v-else>

                
                <form @submit.prevent="submitAttendance">
                    <!-- Student Details -->
                    <div class="studentDetails">
                        <div v-if="student">
                            <h5 class="text-info"><i class="mainIcon bi bi-person-circle"></i> Student Details</h5>
                            <div class="boxst fs-5 fw-bold text-light">{{ student.first_name }} {{ student.last_name }}</div>
                            <div class="boxst text-light">Grade: <span class="fw-semibold">{{ student.grade_id }}</span></div>
                        </div>
                        <!-- <div v-if="studentItem && studentItem.length">
                            <div v-for="item in studentItem" :key="item.id" class="boxst text-light">
                                Subject: <span class="fw-semibold">{{ item.subject?.name }}</span>
                                <p hidden><strong>Teacher ID:</strong> {{ item.teacher?.id }}</p>
                            </div>
                        </div> -->
                        <div v-if="studentItem">
    <div v-for="item in Array.isArray(studentItem) ? studentItem : [studentItem]" :key="item.id" class="boxst text-light">
        Subject: <span class="fw-semibold">{{ item.subject?.name }}</span>
        <p hidden><strong>Teacher ID:</strong> {{ item.teacher?.id }}</p>
    </div>
</div>

                        <!-- <div v-if="studentCode" class="mt-2">
                            <p>Student Code: <span class="badge bg-primary p-2">{{ studentCode.wave_code }}</span>
                            <strong>Reg No:</strong> {{ student.stu_reg_number }}</p>
                        </div> -->
                        <div v-if="studentCode" class="mt-2">
  <p class="mb-0">
    <span class="text-light fw-bold me-1">Student Code:</span>
    <span class="badge bg-primary p-2 me-3">{{ studentCode.wave_code }}</span>

    <span class="text-light fw-bold me-1">Reg No:</span>
    <span class="badge bg-success p-2">{{ student.stu_reg_number }}</span>
  </p>
</div>

                        
                    </div>

                    <!-- Attendance Section -->
                    <div class="attendanceDetails mt-3">
                        <h5><i class="mainIcon bi bi-calendar-check"></i> Attendance</h5>
                        <div class="dropdown">
                            <button class="btn btn-outline-light dropdown-toggle" type="button" data-bs-toggle="dropdown">
                                {{ selectedStatus || "Select Status" }}
                            </button>
                            <ul class="dropdown-menu">
                                <li><a class="dropdown-item" href="#" @click.prevent="selectedStatus = 'Present'">Present</a></li>
                                <li><a class="dropdown-item" href="#" @click.prevent="selectedStatus = 'Absent'">Absent</a></li>
                                <li><a class="dropdown-item" href="#" @click.prevent="selectedStatus = 'Late'">Late</a></li>
                            </ul>
                        </div>

                        <div class="mt-3">
                            <label for="remark" class="form-label"><i class="mainIcon bi bi-chat-left-text"></i> Remark</label>
                            <textarea class="form-control" id="remark" v-model="attendance.remark" rows="2" placeholder="Add remarks..."></textarea>
                        </div>
                    </div>

                    <!-- Payment Section
                    <div v-if="studentItem && studentItem.length" class="paymentDetails mt-3">
                        <h5><i class="mainIcon bi bi-cash"></i> Payment</h5>
                        <div v-for="item in studentItem" :key="item.id" class="paymentClass">
                            <div>
                                <strong>Status: </strong> 
                                <span v-if="isExpired(item.exp_date)" class="text-danger">Expired</span>
                                <span v-else-if="item.status === 'pending'" class="text-warning">Pending</span>
                                <span v-else class="text-success">Completed</span>
                                <div>{{ item.pay_type?.payment_type || 'N/A' }} Payment: <strong>{{ item.amount }}</strong></div>
                            </div>
                            <button type="button" class="btn btn-info btn-sm" @click="goToStudentPayment(item.student_id)">
                                <i class="bi bi-credit-card"></i> Pay Now
                            </button>
                        </div>
                    </div> -->

                    <!-- Payment Section -->
<div v-if="studentItem" class="paymentDetails mt-3">
    <h5><i class="mainIcon bi bi-cash"></i> Payment</h5>
    <div v-for="item in Array.isArray(studentItem) ? studentItem : [studentItem]" :key="item.id" class="paymentClass">
        <div>
            <div>
  <span class="text-warning">Last Payment : </span>
  <span class="text-info fw-bold">{{ item.payment_date.split(' ')[0] }}</span>
  <!-- <span class="text-secondary ms-2">{{ item.payment_date.split(' ')[1] }}</span> -->
            </div>
            <div><strong>Status: </strong> 
            <span v-if="isExpired(item.exp_date)" class="text-danger">Expired</span>
            <span v-else-if="item.status === 'pending'" class="text-warning">Pending</span>
            <span v-else class="text-success">Completed</span></div>
            <div>{{ item.pay_type?.payment_type || 'N/A' }} Payment: <strong>{{ item.amount }}</strong></div>
            
        </div>
        <!-- {{ item.student_id }} {{ item.id }} -->
        <button type="button" class="btn btn-info btn-sm" @click="goToStudentPayment(item.id)">
            <i class="bi bi-credit-card"></i> Pay Now
        </button>
    </div>
</div>


                    <!-- Save Button -->
                    <div class="d-grid gap-2 mt-4">
                        <button class="btn btn-primary" :disabled="isLoading">
                            <i class="bi bi-save"></i> 
                            {{ isLoading ? 'Saving...' : 'SAVE' }}
                        </button>
                    </div>
                </form>
            </div>

            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
export default {
    props: {
        qrData: String,  
        student: Object, 
        studentItem: Array, 
        studentCode: Object, 
    },
    emits: ['close', 'attendanceAdded'],
    data() {
        return {
            selectedStatus: "Present", // Default to "Present"
            attendance: {
                remark: '',
            },
            // selectedStatus: null,
            isLoading: false,
        };
    },

    methods: {
        isExpired(expDate) {
            if (!expDate) return false;
            return new Date(expDate).getTime() < new Date().getTime();
        },

        async submitAttendance() {
    if (!this.selectedStatus) {
        alert("Please select attendance status.");
        return;
    }

    const formData = new FormData();
    formData.append('student_id', this.student?.id || '');
    formData.append('grade_id', this.student?.grade_id || '');
    formData.append('status', this.selectedStatus);
    formData.append('remark', this.attendance.remark || '');

    // Append subject and teacher IDs (studentItem is a single object)
    if (this.studentItem) {
        if (this.studentItem.subject?.id) {
            formData.append('subject_id', this.studentItem.subject.id);
        }
        if (this.studentItem.teacher?.id) {
            formData.append('teacher_id', this.studentItem.teacher.id);
        }
    }

    this.isLoading = true;

    try {
        const response = await axios.post('/attendance-submit', formData);
        if (response.data.success) {
            alert("Attendance submitted successfully!");
            this.$emit('attendanceAdded'); // Notify parent component
            this.$emit('close'); // Close the modal automatically
        }
    } catch (error) {
        this.isLoading = false;

        if (error.response) {
            if (error.response.status === 422) {
                const errors = error.response.data.errors;
                let errorMessage = "Validation failed:\n";
                for (const key in errors) {
                    errorMessage += `${errors[key].join(', ')}\n`;
                }
                alert(errorMessage);
            } else if (error.response.status === 400) {
                alert(error.response.data.message || "An error occurred.");
            } else {
                alert("Server error. Please try again later.");
            }
        } else {
            console.error("Error submitting attendance:", error);
            alert("Network error. Please check your connection.");
        }
    } finally {
        this.isLoading = false;
    }
},

//         async submitAttendance() {
//     if (!this.selectedStatus) {
//         alert("Please select attendance status.");
//         return;
//     }

//     const formData = new FormData();
//     formData.append('student_id', this.student?.id || '');
//     formData.append('grade_id', this.student?.grade_id || '');
//     formData.append('status', this.selectedStatus);
//     formData.append('remark', this.attendance.remark);

//     // Append subject and teacher IDs
//     if (this.studentItem && this.studentItem.length) {
//         this.studentItem.forEach(item => {
//             if (item.subject?.id) {
//                 formData.append('subject_id', item.subject.id);
//             }
//             if (item.teacher?.user?.id) {
//                 formData.append('teacher_id', item.teacher.id);
//             }
//         });
//     }

//     this.isLoading = true;

//     try {
//         const response = await axios.post('/save-student-attendance', formData);
//         if (response.data.success) {
//             alert("Attendance submitted successfully!");
//             this.$emit('attendanceAdded'); // Notify parent component
//             this.$emit('close'); // Close the modal automatically
//         }
//     } catch (error) {
//         this.isLoading = false;

//         if (error.response) {
//             // Check if it's a validation error (status code 422)
//             if (error.response.status === 422) {
//                 const errors = error.response.data.errors;
//                 let errorMessage = "Validation failed:\n";
//                 for (const key in errors) {
//                     errorMessage += `${errors[key].join(', ')}\n`;
//                 }
//                 alert(errorMessage);
//             } 
//             // Custom error from backend (e.g., duplicate attendance)
//             else if (error.response.status === 400) {
//                 alert(error.response.data.message || "An error occurred.");
//             } 
//             // Handle other possible server errors
//             else {
//                 alert("Server error. Please try again later.");
//             }
//         } else {
//             console.error("Error submitting attendance:", error);
//             alert("Network error. Please check your connection.");
//         }
//     } finally {
//         this.isLoading = false;
//     }
// },


        goToStudentPayment(studentItemId) {
            this.$router.push({ name: 'StudentPayment', query: { studentItemId } });
        },


    }
};
</script>

<style lang="scss" scoped>
.body{
    margin: 2%;
}

.topic{
    font-size: 25px;
}
.outlineClass {
    width: 420px;
    background-color: #1a1a1a;
    color: white;
    border-radius: 15px;
    border: 3px solid #6a11cb;
    padding: 20px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.5);
    text-align: left;
}
.title {
    text-transform: uppercase;
    font-weight: bold;
    font-size: 1.4rem;
    padding-bottom: 10px;
    border-bottom: 3px solid #6a11cb;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
h5 {
    color: #00b7ff;
    margin-bottom: 10px;
    font-size: 1.1rem;
}
.studentDetails {
    line-height: 2svh;
}
.boxst {
    width: 80%;
    color: #1a1a1a;
    margin-bottom: 5px;
    padding: 5px;
    border-radius: 5px;
    background: linear-gradient(90deg,#6a11cb,rgb(255, 0, 140));
}
.paymentClass {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.btn-primary {
    width: 100%;
    font-weight: bold;
    background: linear-gradient(90deg, #6a11cb, #2575fc);
    border: none;
    transition: 0.3s;
}
.btn-primary:hover {
    background: linear-gradient(90deg, #2575fc, #6a11cb);
}
.mainIcon {
    margin-right: 8px;
    color: #00b7ff;
}
.badge {
    background-color: #2575fc;
}
.btn-danger {
    background-color: #ff41b0;
    border: none;
}
.btn-danger:hover {
    background-color: #ff6889;
}
textarea.form-control {
    resize: none;
    background-color: #666666;
    color: white;
    border: 1px solid #6a11cb;
}
.dropdown-menu {
    background-color: #1a1a1a;
    border: none;
}
a {
    color: white !important;
}
a:hover {
    color: black !important;
}


@media (max-width: 768px) {

    .body{
    margin: 2%;
}

.topic{
    font-size: 20px;
}

    .outlineClass {
    width: auto;
    border-radius: 15px;
    padding: 10px;
}

}
</style>
